const msg = {
  APP_NAME: "球记",
  COPYRIGHT: "成都菠萝科技有限公司 © 2020",

  FORM_VALIDATION_REQUIRED: "必填",
  FORM_VALIDATION_INVALID_EMAIL: "无效的邮箱地址",
  FORM_VALIDATION_LENGTH: "长度不能超过{length}字节",

  LOGIN_FORM_EMAIL: "邮箱",
  LOGIN_FORM_PASSWORD: "密码",
  LOGIN_FORM_LOGIN: "登录",
  LOGIN_FORM_FORGET_PASSWORD: "忘记密码?",
  LOGIN_FORM_CREATE_ACCOUNT: "创建账号",
  LOGIN_NO_ACCOUNT_YET: "还没有账号吗?",
  LOGIN_SIGNUP: "注册",
  LOGIN_FAILED_SNACKBAR: "登录失败，请检查输入的用户名和账号后再次尝试登录",
  LOGIN_REDIRECT_DASHBOARD_BUTTON: "进入系统",

  LANGUAGE_SELECTOR_LABEL: "语言",

  TEAM_SELECTOR_PROMPT_OPTION: "选择球队",

  PAGE_NOT_FOUND_TEXT: "咦, 这个页面不存在 :(",
  PAGE_NOT_FOUND_GO_BACK: "回首页",

  REGISTER_TITLE: "注册新用户",
  REGISTER_FORM_EMAIL: "邮箱",
  REGISTER_FORM_PASSWORD: "密码",
  REGISTER_FORM_REPEAT_PASSWORD: "重复密码",
  REGISTER_FORM_NAME: "昵称",
  REGISTER_FORM_GENDER: "性别",
  REGISTER_FORM_ADDRESS: "地址",
  REGISTER_FORM_DESCRIPTION: "备注",
  REGISTER_FORM_INVITE_CODE: "邀请码",
  REGISTER_FORM_WEIGHT: "体重",
  REGISTER_FORM_REGISTER: "注册",
  REGISTER_PASSWORD_NOT_MATCH: "两次输入的密码不匹配",
  REGISTER_FORM_INVITE_CODE_DESC:
    "内测期，仅限受邀请用户注册。请联系smilingky@gmail.com获取邀请码。",
  REGISTER_INVALID_INVITE_CODE:
    "不正确的邀请码，请联系管理员smilingky@gmail.com",
  REGISTER_EMAIL_REGISTERED: "邮箱已经被占用，请使用其他邮箱账号",
  REGISTER_SUCC: "注册成功，请登录",

  FORGET_PASSWORD_TITLE: "我们会给你的邮箱发送重置密码的链接",
  FORGET_PASSWORD_SUBMIT: "发送",

  RESET_PASSWORD_TITLE: "重置您的密码",
  RESET_FORM_PASSWORD: "新密码",
  RESET_FORM_REPEAT_PASSWORD: "重复新密码",
  RESET_FORM_SUBMIT: "重置",

  GENDER_SELECT_MALE: "男",
  GENDER_SELECT_FEMALE: "女",

  NO_DATA: "没有数据",

  SIDEBAR_OVERVIEW: "总览",
  SIDEBAR_CALENDAR: "活动日历",
  SIDEBAR_TEAMS: "球队信息",
  SIDEBAR_EVENTS: "赛事",
  SIDEBAR_VIDEO_ANALYZE: "视频分析",
  SIDEBAR_VIDEO_MANAGE: "视频管理",
  SIDEBAR_MANAGE: "管理区",
  SIDEBAR_MANAGE_CREATE_MATCH: "创建比赛",
  SIDEBAR_MANAGE_BATCH_REG_PLAYER: "批量注册球员",
  SIDEBAR_MANAGE_BATCH_REG_TEAM: "注册球队",
  SIDEBAR_MANAGE_UPDATE_APP: "更新APP",
  SIDEBAR_ANIMATION: "动画Demo",

  TOP_BAR_OPTION_PROFILE: "个人资料",
  TOP_BAR_OPTION_LOGOUT: "注销",

  EVENTS_VIEW_TITLE: "赛事",
  EVENTS_VIEW_ONGOING: "进行中的赛事",
  EVENTS_VIEW_FINISHED: "已结束的赛事",
  EVENTS_VIEW_NOT_STARTED: "未开始的赛事",
  EVENTS_VIEW_TEAMS: "球队",
  EVENTS_VIEW_CALENDAR: "日程",

  MEDIA_UPLOAD: "上传",
  MEDIA_CANCEL: "取消",
  MEDIA_DRAG_FILE: "请拖动文件到这里",
  MEDIA_UPLOAD_SUCCESS: "文件上传成功",
  MEDIA_LABEL_REMARK: "备注",
  MEDIA_SUBMIT: "提交",
  MEDIA_UPDATE_REMARK_SUCCESS: "备注更改成功",
  MEDIA_MANAGE_MEDIA_LIBRARY: "媒体库",
  MEDIA_QUERY_FAILED: "媒体列表查询失败",
  MEDIA_CREATE_AT: "创建于",
  MEDIA_UPDATE_AT: "更新于",
  MEDIA_REMARK_MODIFY: "修改备注",
  MEDIA_COPY_URL: "复制地址",
  MEDIA_NOTIFICATION_URL_COPIED: "网址已复制",

  TEAMS_MANAGE_TITLE: "球队管理",
  TEAMS_MANAGE_LIST: "球队列表",
  TEAMS_MANAGE_EDIT: "编辑球队",
  TEAMS_MANAGE_DELETE: "解散球队",
  TEAMS_MANAGE_SET_DEFAULT: "设成默认",
  TEAMS_MANAGE_NO_TEAMS: "您还没有加入任何球队，请创建或加入一支球队",
  TEAM_PLAYER_NUM: "{num}个队员",
  TEAM_MANAGE_ADD: "创建球队",
  TEAM_MANAGE_SEARCH: "搜索球队",
  TEAM_MANAGE_DELETE_PLAYER: "移出球队",
  TEAM_EDIT_NAME: "球队名称",
  TEAM_EDIT_LOCATION: "所在位置",
  TEAM_EDIT_PLAYERS: "队员列表",
  TEAM_EDIT_ADD_PLAYER: "添加队员",
  TEAM_EDIT_PLAYERS_TIPS:
    "队员的注册邮箱，以分号(;)为分隔符, 例如player1@gmail.com;player2@gmail.com",
  TEAM_EDIT_DESCRIPTION: "描述",
  TEAM_SUBMIT: "提交",
  TEAM_UPDATE: "更新",
  TEAM_UPDATE_SUCCESS: "队伍信息更新成功",
  TEAM_UPDATE_FAILED: "队伍信息更新失败",
  TEAM_CREATE_FAILED: "创建球队失败，请稍后重试",
  TEAM_CREATE_SUCCESS: "创建球队成功",
  TEAM_CREATE_SUCCESS_ACCOUNT_INVITE_FAILED:
    "球队已创建成功，但以下账号({accounts})还未在球记系统中注册，请邀请他们注册账号",
  TEAM_EDIT_BUTTON_ADD_PLAYER: "添加",
  TEAM_EDIT_BUTTON_ADD_PLAYER_CANCEL: "取消",
  TEAM_ADD_PLAYER_ERROR:
    "添加队员失败，请检查输入的邮箱是否正确，注意分号（；）为分隔符",
  TEAM_ADD_PLAYER_SUCCESS: "添加队员成功",
  TEAM_REMOVE_PLAYER_ERROR: "删除队员失败",
  TEAM_REMOVE_PLAYER_IS_OWNER: "不能删除球队管理员",
  TEAM_REMOVE_PLAYER_SUCCESS: "删除队员成功",
  PLAYER_NOT_ASSIGN_NUMBER: "暂未分配号码",

  CALENDAR_CREATE_MATCH: "创建比赛",

  HOME_TEAM_DATA: "主队数据",
  AWAY_TEAM_DATA: "客队数据",

  MATCH_DASHBOARD_NONBALL_STATS_COMPARE: "无球数据对比",
  MATCH_DASHBOARD_NONBALL_STATS_COMPARE_DESC: "（跑动能力）",
  MATCH_DASHBOARD_WITHBALL_STATS_COMPARE: "有球数据对比",
  MATCH_DASHBOARD_WITHBALL_STATS_COMPARE_DESC: "（带球技术能力）",
  MATCH_DASHBOARD_MATCH_STATS: "比赛统计",
  MATCH_DASHBOARD_STATS_WITHBALL_MANUAL_INPUT: "有球录入",
  MATCH_DASHBOARD_STATS_SELECT_SELECT_PLAYERS: "选择球员",
  MATCH_DASHBOARD_STATS_SELECT_SELECT_ACTIONS: "选择动作",
  MATCH_DASHBOARD_STATS_SELECT_SELECT_RESULTS: "选择结果",
  MATCH_DASHBOARD_STATS_SELECT_SELECT_POSSESSION_STATUS: "选择球权状态",

  STATS_LABEL_TOUCH_BALL: "触球区域",
  STATS_LABEL_SAVE: "扑救",
  STATS_LABEL_CLEAR: "解围",
  STATS_LABEL_PASS: "传球",
  STATS_LABEL_TACKLE: "抢断",
  STATS_LABEL_SHOOT: "射门",
  STATS_LABEL_DRIBBLE: "过人",
  STATS_LABEL_INTERCEPTION: "拦截",
  STATS_LABEL_CROSS: "传中",
  STATS_LABEL_FOUL: "犯规",
  STATS_LABEL_THROUGH: "直塞",
  STATS_LABEL_BLOCK: "阻挡",
  STATS_LABEL_ASSIST: "助攻",
  STATS_LABEL_OFFSIDE: "越位",
  STATS_LABEL_OWNGOAL: "乌龙",
  STATS_LABEL_FREEKICK: "任意球",
  STATS_LABEL_CORNER: "角球",
  STATS_LABEL_PENALTY: "点球",
  STATS_LABEL_YELLOW: "黄牌",
  STATS_LABEL_RED: "红牌",
  STATS_LABEL_DISCIPLINE: "纪律",
  STATS_LABEL_PASSER: "传球人",
  STATS_LABEL_RECEIVER: "接球人",
  STATS_LABEL_RECEIVE: "接球",
  STATS_LABEL_NUMBER: "次数",
  STATS_LABEL_ACTIVE_VALUE: "活跃值",
  STATS_LABEL_ACTIVE_EVENT_DISTANCE: "活跃事件总距离",
  STATS_LABEL_EFFECTIVE_EVENT_DISTANCE: "有效活跃事件距离",
  STATS_LABEL_ACTIVE_EVENT_AMOUNT: "事件数量",
  STATS_LABEL_EFFECTIVE_ACTIVE_EVENT_AMOUNT: "有效事件数量",
  STATS_LABEL_ACTIVE_EVENT_DISTANCE_DESC:
    "由球场事件的位置差相加所得，表明该球员在球场上的覆盖范围，数值越大覆盖距离越大。",
  STATS_LABEL_EFFECTIVE_EVENT_DISTANCE_DESC:
    "是活跃事件总距离概念的子集，规则是如果该球员是事件发起方，不管事件成功与否都计算在内。但如果该球员是事件接收方，只计算成功的事件。",
  STATS_LABEL_ACTIVE_EVENT_AMOUNT_DESC:
    "所有与该球员相关的球场事件，比如传球，射门，过人等，包括事件的发起方和接收方。  ",
  STATS_LABEL_EFFECTIVE_ACTIVE_EVENT_AMOUNT_DESC:
    "是活跃事件概念的子集，规则是如果该球员是事件发起方，不管事件成功与否都计算在内。但如果该球员是事件接收方，只计算成功的事件。",

  STATS_LABEL_SPEED: "速度",
  STATS_LABEL_DISTANCE: "总距离",
  STATS_LABEL_WALK: "走",
  STATS_LABEL_JOGGING: "慢跑",
  STATS_LABEL_RUN: "跑",
  STATS_LABEL_SPRINT: "冲刺",
  STATS_LABEL_ATTACK: "进攻",
  STATS_LABEL_DEFENCE: "防守",
  STATS_LABEL_CALORIE: "能量消耗",

  STATS_SUCC: "成功",
  STATS_FAIL: "失败",
  STATS_POS_SELF: "己方半场",
  STATS_POS_OTHER: "对方半场",
  STATS_POSSESSION: "球权",
  STATS_POSSESSION_WIN: "赢得球权",
  STATS_POSSESSION_LOSE: "丢失球权",

  SCHEDULE_LABEL: "活动日程表",
  SCHEDULE_CALENDAR_WHOLE_DAY: "整天",
  SCHEDULE_CALENDAR_LAST_MONTH: "上个月",
  SCHEDULE_CALENDAR_NEXT_MONTH: "下个月",
  SCHEDULE_CALENDAR_TODAY: "今天",
  SCHEDULE_CALENDAR_MONTH: "月",
  SCHEDULE_CALENDAR_WEEK: "周",
  SCHEDULE_CALENDAR_DAY: "日",
  SCHEDULE_CALENDAR_AGENDA: "日程",
  SCHEDULE_CALENDAR_MORE: "查看更多",

  MATCH_TEAM_TITLE: "详细数据",
  STATS_TEAM_TITLE: "{year}年度详细数据",
  MATCH_TEAM_TAB_TEAM_OVERVIEW: "球队总览",
  MATCH_TEAM_TAB_TEAM_STATS_BOARD: "战术板",
  MATCH_TEAM_NO_DATA: "还没有给球队录入数据",

  MATCH_TEAM_OVERVIEW_PASS_TOTAL: "传球总数",
  MATCH_TEAM_OVERVIEW_FORWARD_PASS_TOTAL: "向前传球",
  MATCH_TEAM_OVERVIEW_BACKWARD_PASS_TOTAL: "向后传球",
  MATCH_TEAM_OVERVIEW_CROSS_PASS_TOTAL: "横向传球",
  MATCH_TEAM_OVERVIEW_SHORT_PASS_TOTAL: "短传",
  MATCH_TEAM_OVERVIEW_LONG_PASS_TOTAL: "长传",
  MATCH_TEAM_OVERVIEW_THROW_IN_PASS_TOTAL: "界外球",
  MATCH_TEAM_OVERVIEW_OWN_HALF_PASS_TOTAL: "己方半场传球",
  MATCH_TEAM_OVERVIEW_OTHER_HALF_PASS_TOTAL: "对方半场传球",
  MATCH_TEAM_OVERVIEW_PASS_SUCC: "传球成功",
  MATCH_TEAM_OVERVIEW_PASS_SUCC_RATE: "成功率",
  MATCH_TEAM_OVERVIEW_TABLE_DESC: "传球方 \\\\ 接球方",
  MATCH_TEAM_OVERVIEW_SHOOT_TOTAL: "射门总数",
  MATCH_TEAM_OVERVIEW_SHOOT_IN_PENALTY_TOTAL: "禁区内射门数",
  MATCH_TEAM_OVERVIEW_SHOOT_OUT_PENALTY_TOTAL: "禁区外射门数",
  MATCH_TEAM_OVERVIEW_SHOOT_IN_TARGET: "命中球门范围",
  MATCH_TEAM_OVERVIEW_SHOOT_GOAL: "进球数",
  MATCH_TEAM_OVERVIEW_SHOOT_CHART_TITLE: "射门次数",
  MATCH_TEAM_OVERVIEW_LAST_PASS_CHART_TITLE: "最后一传",
  MATCH_TEAM_OVERVIEW_ASSIST_TOTAL: "总次数",
  MATCH_TEAM_OVERVIEW_DRIBBLE_ATTEMPT_TOTAL: "尝试过人次数",
  MATCH_TEAM_OVERVIEW_DRIBBLE_SUCC: "成功过人次数",

  MATCH_TEAM_PERSONAL_VIEW_PASS_TO_CHART_TITLE: "我给谁传球",
  MATCH_TEAM_PERSONAL_VIEW_PASS_FROM_CHART_TITLE: "谁给我传球",
  MATCH_TEAM_PERSONAL_VIEW_PASS_CHART_TOTAL: "成功传球",
  MATCH_TEAM_PERSONAL_VIEW_SHOOT_LEFT: "左脚射门次数",
  MATCH_TEAM_PERSONAL_VIEW_SHOOT_RIGHT: "右脚射门次数",
  MATCH_TEAM_PERSONAL_VIEW_SHOOT_HEADER: "头球射门次数",
  MATCH_TEAM_PERSONAL_VIEW_SHOOT_CHART_TITLE: "谁给我最后一传",
  MATCH_TEAM_PERSONAL_VIEW_SHOOT_CHART_BY_ME: "我自己",
  MATCH_TEAM_PERSONAL_VIEW_SHOOT_SKETCH_MAP_TITLE: "射门线路示意图",

  BC_TEAMS_MANAGE_HOME: "球队管理",
  BC_TEAMS_MANAGE_CREATE: "创建球队",
  BC_TEAMS_MANAGE_EDIT: "编辑球队",
  BC_TEAMS_MANAGE_VIEW: "球队信息",

  FORM_GENERAL_CANCEL: "取消",

  CREATE_MATCH_FIELD_LEAGUE: "联赛",
  CREATE_MATCH_FIELD_LOCATION: "地点",
  CREATE_MATCH_FIELD_TIME: "时间",
  CREATE_MATCH_FIELD_HOME_TEAM: "主队",
  CREATE_MATCH_FIELD_AWAY_TEAM: "客队",
  CREATE_MATCH_FIELD_DESCRIPTION: "备注",
  CREATE_MATCH_FIELD_PLAYER_NUM: "比赛人数",
  CREATE_MATCH_VALIDATION_AT_LEAST_ONE_TEAM_VALID: "请确保录入至少一支球队",
  CREATE_MATCH_FAILED: "创建比赛失败",
  CREATE_MATCH_SUCCESS: "创建比赛成功",

  WITHBALL_INPUT_URL_PLACEHOLDER: "视频地址",
  WITHBALL_INPUT_VIDEO_LOAD_BUTTON: "加载",
  WITHBALL_DATETIME_SYNC_BUTTON: "同步",
  WITHBALL_VIDEO_TIME: "视频时间",
  WITHBALL_MATCH_TIME: "比赛时间",

  STAT_ACTION_PASS_SHORT: "传球",
  STAT_ACTION_THROUGH_SHORT: "直塞",
  STAT_ACTION_DRIBBLE_SHORT: "过人",
  STAT_ACTION_SHOOT_SHORT: "射门",
  STAT_ACTION_OFFSIDE_SHORT: "越位",
  STAT_ACTION_TACKLE_SHORT: "抢断",
  STAT_ACTION_INTERCEPTION_SHORT: "截断",
  STAT_ACTION_BLOCK_SHORT: "阻断",
  STAT_ACTION_CLEARANCE_SHORT: "解围",
  STAT_ACTION_SAVING_SHORT: "扑救",
  STAT_ACTION_OWNGOAL_SHORT: "乌龙",
  STAT_ACTION_FREE_KICK_SHORT: "任意",
  STAT_ACTION_CORNER_KICK_SHORT: "角球",
  STAT_ACTION_PENALTY_KICK_SHORT: "点球",
  STAT_ACTION_FOUL_SHORT: "犯规",
  STAT_ACTION_YELLOW_SHORT: "黄牌",
  STAT_ACTION_RED_SHORT: "红牌",

  STAT_ACTION_SWITCH: "切换",

  STAT_ACTION_PASS: "传球",
  STAT_ACTION_THROUGH: "直塞",
  STAT_ACTION_DRIBBLE: "过人",
  STAT_ACTION_SHOOT: "射门",
  STAT_ACTION_OFFSIDE: "越位",
  STAT_ACTION_TACKLE: "抢断",
  STAT_ACTION_INTERCEPTION: "截断",
  STAT_ACTION_BLOCK: "阻断",
  STAT_ACTION_CLEARANCE: "解围",
  STAT_ACTION_SAVING: "扑救",
  STAT_ACTION_OWNGOAL: "乌龙",
  STAT_ACTION_FREE_KICK: "任意",
  STAT_ACTION_CORNER_KICK: "角球",
  STAT_ACTION_PENALTY_KICK: "点球",
  STAT_ACTION_FOUL: "犯规",
  STAT_ACTION_YELLOW: "黄牌",
  STAT_ACTION_RED: "红牌",

  STAT_FORM_LABEL_TEAM: "球队",
  STAT_FORM_LABEL_HOME: "主队",
  STAT_FORM_LABEL_AWAY: "客队",
  STAT_FORM_LABEL_ACTION_TYPE: "动作",
  STAT_FORM_LABEL_PLAYER: "球员",
  STAT_FORM_LABEL_METHOD: "类型",
  STAT_FORM_LABEL_BODY_PART: "部位",
  STAT_FORM_LABEL_THREAT: "威胁",
  STAT_FORM_LABEL_RESULT: "结果",
  STAT_FORM_LABEL_POSSESSION: "球权",
  STAT_FORM_LABEL_HOME_TEAM_SIDE: "主队方向",
  STAT_FORM_LABEL_IN_TARGET: "球门范围",
  STAT_FORM_LABEL_SUBMIT: "添加记录",
  STAT_FORM_SUBMIT_MATCH_RESULT: "提交比赛结果",
  STAT_SCORES_FROM_INPUT_LIST: "记录中检测到{scores}个进球",
  STAT_HOME_SCORES: "主队进球",
  STAT_AWAY_SCORES: "客队进球",

  STAT_PASS_SHORT: "短传",
  STAT_PASS_LONG: "长传",
  STAT_PASS_THROW_IN: "界外球",

  STAT_SHOOT_IN_PENALTY: "禁区内",
  STAT_SHOOT_OUT_PENALTY: "禁区外",

  STAT_TACKLE_NORMAL: "普通",
  STAT_TACKLE_SLIDING: "铲球",

  STAT_PASS_FOOT: "脚",
  STAT_PASS_HEAD: "头",

  STAT_SHOOT_RIGHT_FOOT: "右脚",
  STAT_SHOOT_LEFT_FOOT: "左脚",
  STAT_SHOOT_HEAD: "头球",

  STAT_RESULT_SUCCESS: "成功",
  STAT_RESULT_FAILED: "失败",

  STAT_POSSESSION_WIN: "赢得",
  STAT_POSSESSION_KEEP: "保持",
  STAT_POSSESSION_LOSE: "失去",

  STAT_HOME_TEAM_LEFT: "左侧",
  STAT_HOME_TEAM_RIGHT: "右侧",

  STAT_FREEKICK_DIRECT: "直接",
  STAT_FREEKICK_INDIRECT: "间接",

  STAT_NOTIFICATION_WITHBALL_POST_SUCCESS: "数据提交成功",
  STAT_NOTIFICATION_WITHBALL_POST_FAILED: "数据提交失败",
  STAT_NOTIFICATION_WITHBALL_DELETE_FAILED: "数据删除失败",

  STAT_TABLE_HEADER_TEAM: "球队",
  STAT_TABLE_HEADER_ACTION: "动作",
  STAT_TABLE_HEADER_FROM: "动作发起",
  STAT_TABLE_HEADER_TO: "动作接收/助攻",
  STAT_TABLE_HEADER_POSSESSION: "控球",
  STAT_TABLE_HEADER_RESULT: "结果",
  STAT_TABLE_HEADER_OPERATION: "操作",
  STAT_TABLE_HEADER_POSITOIN: "位置",
  STAT_TABLE_HEADER_TIMESTAMP: "时间戳(秒)",
  STAT_TABLE_HEADER_PLAY: "播放",

  NONE_TEAM_SELECTED: "没有选择队伍",
  TEAM_NOT_REGISTERED: "队伍未注册",
  NONE_PLAYER_SELECTED: "没有选择队员",

  MATCH_STATS_TITLE: "比赛统计",
  MATCH_STATS_TECHNICAL_STATISTICS: "技术统计",
  MATCH_STATS_DATA_INPUT: "录入数据",
  MATCH_STATS_HOME_TEAM_DATA: "主队数据",
  MATCH_STATS_AWAY_TEAM_DATA: "客队数据",
  MATCH_STATS_TEAM_OVERALL: "球队总览",
  MATCH_STATS_UNKNOWN_PLAYER: "未知队员",
  MATCH_RESULT_SUBMIT_SUCC: "比赛结果已提交",

  EDIT_STATS_DIALOG_TITLE: "修改数据",
  EDIT_STATS_DIALOG_CANCEL: "取消",
  EDIT_STATS_DIALOG_UPDATE: "修改",

  LANDING_DESC_TITLE: "您的线上足球数据分析师",
  LANDING_DESC_SUB_TITLE:
    "为每一支球队提供技术统计分析的线上服务，让足球更专业，更有趣",
  LANDING_VALUE_EASY_TO_USE_TITLE: "使用简单",
  LANDING_VALUE_EASY_TO_USE_DESC:
    "赛后坐在电脑前，喝着咖啡，看着录像轻松完成技术数据录入，也可以把视频录像交给我们的专业人员来帮您录入。",
  LANDING_VALUE_COMPREHENSIVE_DATA_TITLE: "全面的数据采集",
  LANDING_VALUE_COMPREHENSIVE_DATA_DESC:
    "为球队提供亲民价格的穿戴式设备来采集队员的运动和位置数据。",
  LANDING_HELP_TILE: "有任何需要帮助的地方，请联系我们！",
  LANDING_HELP_DESC:
    "此系统本用于自己球队的日常比赛训练比赛，现开放出来供广大草根球队教练们使用。如果你有需要，请联系我创建测试账号。",

  SEND_RESET_PASSWORD_EMAIL_SUCCESS: "邮件发送成功，请检查您的邮箱。",
  SEND_RESET_PASSWORD_EMAIL_FAILED: "无法发送邮件，请稍后再试!",
  SEND_RESET_PASSWORD_NOT_MATCH: "两次输入的密码不一致!",
  RESET_PASSWORD_SUCCESS: "密码更新成功， 请重新登录。",
  RESET_PASSWORD_FAILED: "密码更新失败，请重新申请密码重置!",

  ROLE_ADMIN: "系统管理员",
  ROLE_TEAM_MANAGER: "球队管理员",
  ROLE_MATCH_ADMIN: "比赛记录员",
  ROLE_NORMAL: "队员",

  PLAYER_EDIT_NUMBER: "号码",
  PLAYER_EDIT_ROLE: "权限",
  PLAYER_EDIT_SAVE: "保存",
  PLAYER_EDIT_REMOVE: "移除",
  PLAYER_EDIT_SUCCESS: "更新成功",
  PLAYER_EDIT_NUMBER_FAILED: "更改号码失败",
  PLAYER_EDIT_ROLES_FAILED: "修改权限失败",

  TEAM_DASHBOARD: "球队数据总览",
  TEAM_DASHBOARD_CURRENT_TEAM: "当前球队",
  TEAM_DASHBOARD_NAV_MANAGE: "管理球队",
  TEAM_DASHBOARD_NAV_EVENT_ON_VIDEO: "查看比赛事件",
  TEAM_DASHBOARD_NAV_EVENT_CHART: "查看图表",
  TEAM_DASHBOARD_PLAYERS: "共 { playerNum } 名队员",
  TEAM_DASHBOARD_ANNUAL_DATA: "年度数据",
  TEAM_DASHBOARD_ANNUAL_MATCH_1: "今年共踢了 { matchNum } 场比赛",
  TEAM_DASHBOARD_ANNUAL_MATCH_2:
    "胜 { win } 场, 输 { lose } 场, 平 { draw } 场",
  TEAM_DASHBOARD_ANNUAL_MATCH_3:
    "总进球 { totalScores } 个, 场均{ averageScores } 个. 总丢球 { totalLoseScores } 个, 场均 {averageLoseScores} 个",
  TEAM_DASHBOARD_ANNUAL_PLAYER_RANKING: "队员年度数据",
  TEAM_DASHBOARD_ANNUAL_PLAYER_DETAIL_DATA: "查看详细",
  TEAM_DASHBOARD_ANNUAL_PLAYER_SCORE: "进球",
  TEAM_DASHBOARD_ANNUAL_PLAYER_ASSISTANT: "助攻",
  TEAM_DASHBOARD_ANNUAL_PLAYER_TACKLE: "抢断",
  TEAM_DASHBOARD_ANNUAL_PLAYER_INTERCEPTION: "拦截",
  TEAM_DASHBOARD_ANNUAL_PLAYER_PASS_TOTAL: "传球总数",
  TEAM_DASHBOARD_ANNUAL_PLAYER_PASS_RATE: "传球成功率",
  TEAM_DASHBOARD_ANNUAL_PLAYER_DRIBBLE: "过人",
  TEAM_DASHBOARD_LEGEND_GOAL_DIFFERENCE: "净胜球",
  TEAM_DASHBOARD_EXPORT_VIDEO: "导出视频",
  TEAM_DASHBOARD_VIDEO_SELECT: "个视频已勾选",
  TEAM_DASHBOARD_PLAY_VIDEO: "播放视频",
};

export default msg;
